'use client'
import { useEffect } from 'react'
import { useBooking } from '../model/bookingContext'

export function SessionRecoveryNotification() {
  const { dispatch } = useBooking()

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Check if we should show the notification
      const shouldShow = window.sessionStorage.getItem('showRecoveryNotification') === 'true'
      if (shouldShow) {
        // Clear the flag immediately
        window.sessionStorage.setItem('showRecoveryNotification', 'false')

        // Create and show a custom notification
        const notificationContainer = document.createElement('div')
        notificationContainer.className = 'fixed top-4 right-4 z-50 bg-white shadow-lg rounded-lg p-4 max-w-md animate-fade-in border border-green-500'
        notificationContainer.innerHTML = `
            <div class="flex flex-col">
                <span class="font-medium text-green-600">Session Recovered</span>
                <span class="text-sm">We've restored your previous booking session.</span>
                <div class="mt-2 flex space-x-2">
                    <button id="reset-session" class="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100">
                        Start Fresh
                    </button>
                    <button id="continue-session" class="px-3 py-1 text-sm bg-primary text-white rounded hover:bg-primary-dark">
                        Continue
                    </button>
                </div>
            </div>
        `

        document.body.appendChild(notificationContainer)

        // Add event listeners to buttons
        document.getElementById('reset-session')?.addEventListener('click', () => {
          // Reset the booking state
          dispatch({ type: 'RESET_STATE' })
          notificationContainer.remove()
        })

        document.getElementById('continue-session')?.addEventListener('click', () => {
          notificationContainer.remove()
        })

        // Auto-remove after 10 seconds
        setTimeout(() => {
          if (document.body.contains(notificationContainer)) {
            notificationContainer.remove()
          }
        }, 10000)
      }
    }
  }, [dispatch])

  return null // This is just a hook component, no UI needed
}
